import { InvoicePortalButtonPlacement } from "@dillon/Components/InvoicePortalButtonCore";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

/**
 * Visibility rules for Invoice Portal Button placements.
 * - header: desktop header (always available; CSS limits to desktop)
 * - headerMobile: mobile header bar; hidden on Invoice History (page button takes over)
 * - invoiceHistory: only on Invoice History page (mobile via CSS)
 */
export const shouldShowInvoicePortalButtonPlacement = (
    placement: InvoicePortalButtonPlacement,
    state: ApplicationState,
) => {
    const isOnInvoiceHistoryPage = getCurrentPage(state).type === "InvoiceHistoryPage";

    if (placement === "invoiceHistory" && !isOnInvoiceHistoryPage) {
        return false;
    }

    if (placement === "headerMobile" && isOnInvoiceHistoryPage) {
        return false;
    }

    return true;
};
